import { type ReactElement } from 'react';
import { Box, LockIcon, Text } from '@/ui/primitives';
import { ProjectBadge } from './ProjectBadge';
import {
  buildProjectSelectOptionNameTextSx,
  buildProjectSelectOptionRootSx,
  projectSelectOptionContentGap,
  projectSelectOptionLockIconSx,
  projectSelectOptionLockReasonSx,
  projectSelectOptionTextFrameSx,
} from './ProjectSelectOptionContent.styles';
import type { ProjectDto } from '@flowqa/shared';

export type ProjectSelectOptionContentProject = Pick<
  ProjectDto,
  'badgeChars' | 'badgeColor' | 'badgeEnabled' | 'name'
> & {
  locked?: boolean;
  lockReason?: string | null;
};

type ProjectSelectOptionContentProps = {
  project: ProjectSelectOptionContentProject;
  contentGap?: string;
  selectedValue?: boolean;
};

export const ProjectSelectOptionContent = ({
  contentGap = projectSelectOptionContentGap,
  project,
  selectedValue = false,
}: ProjectSelectOptionContentProps): ReactElement => (
  <Box sx={buildProjectSelectOptionRootSx({ contentGap, selectedValue })}>
    {project.badgeEnabled ? (
      <ProjectBadge
        chars={project.badgeChars}
        color={project.badgeColor}
        disabled={project.locked === true}
      />
    ) : null}
    <Box sx={projectSelectOptionTextFrameSx}>
      <Text
        role="body"
        component={selectedValue ? 'span' : undefined}
        truncate
        sx={buildProjectSelectOptionNameTextSx(selectedValue)}
      >
        {project.name}
      </Text>
      {project.locked === true && project.lockReason ? (
        <Text role="caption" color="textSecondary" truncate sx={projectSelectOptionLockReasonSx}>
          {project.lockReason}
        </Text>
      ) : null}
    </Box>
    {project.locked === true ? <LockIcon sx={projectSelectOptionLockIconSx} /> : null}
  </Box>
);
